import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { consentClient } from '@integration/api-client/consent';

export const { actions, effects } = generateNgrxServiceClient(
  'Consent',
  consentClient
);
